import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { FinancialTab } from '../../Financial/FinancialTab';
export function FinancialPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(FinancialTab, {
            programId: programId
        })
    });
}
